'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var resolveBuilder = exports.resolveBuilder = function resolveBuilder() {
  return import( /* webpackChunkName: "conversations-internal-pub-sub-client-builder" */
  'conversations-internal-pub-sub/conversations-pub-sub/builders/buildConversationsPubSub');
};